import { Component} from 'vue-property-decorator';
import { ItiBaseModal, ItiForm, ItiTextField, ItiTextArea, ItiDatePicker, ItiCheckbox, ItiRadioButton, ItiSelect, ItiRadioButtonGroup } from '@/iti-core-vuetify';


@Component({
    components: {
        ItiForm,
        ItiTextField,
        ItiTextArea,
        ItiDatePicker,
        ItiCheckbox,
        ItiRadioButton,
        ItiRadioButtonGroup,
        ItiSelect,

    },
})
export default class Formulario extends ItiBaseModal {
    public datosEjemplo = {
        nombre: '',
        email: '',
        password: '',
        hora_registro: '',
        fecha_registro: null,
        genero: '',
        arrayRadioButtons: ["Hombre", "Mujer"],
        itemsSelec: ['Option1','Option2','Option3'],
        seleccionado: '',
        comentarios: '',
        condiciones: '',
    };
    
    public saveEntity() {
        //console.log(this.datosEjemplo);
    }
}
